import { useRouter } from 'next/router'

const useIsOnlineCasino = () => {
    const { asPath } = useRouter()

    return asPath?.includes('/online-casino/')
}

export default useIsOnlineCasino
